import ltDecline from "./lt.mjs"

/**
 * @param {string} word
 * @param {string} declension - Declension key (language-specific).
 * @param {string} lang - ISO language code (only `lt` has specialized handling).
 * @returns {string} Declined form, or `word` unchanged when unsupported.
 */
export default function decline(word, declension, lang) {
  if (lang === "lt") return ltDecline(word, declension)
  return word
}
